import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

const ABOUT_IMAGE = "https://images.unsplash.com/photo-1521737711867-e3b97375f902?q=80&w=1974&auto=format&fit=crop";

const values = [
  {
    icon: 'fa-handshake',
    title: 'Confianza',
    description: 'Construimos relaciones duraderas basadas en la transparencia y honestidad.'
  },
  {
    icon: 'fa-star',
    title: 'Excelencia',
    description: 'Nos esforzamos por ofrecer el mejor servicio y asesoramiento personalizado.'
  },
  {
    icon: 'fa-heart',
    title: 'Compromiso',
    description: 'Tu tranquilidad es nuestra prioridad, estamos siempre disponibles para vos.'
  },
  {
    icon: 'fa-lightbulb',
    title: 'Innovación',
    description: 'Adaptamos nuestras soluciones a las necesidades cambiantes del mercado.'
  }
];

export const About = () => {
  return (
    <section id="nosotros" className="py-24 bg-background">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src={ABOUT_IMAGE} 
                alt="Equipo Organizacion Ram" 
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/40 to-transparent"></div>
            </div>
            
            {/* Floating stats card */}
            <div className="absolute -bottom-8 -right-8 bg-card rounded-2xl p-6 shadow-xl border border-border hidden md:block">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 bg-primary rounded-2xl flex items-center justify-center">
                  <i className="fas fa-award text-3xl text-primary-foreground"></i>
                </div>
                <div>
                  <p className="text-3xl font-bold text-foreground">+15</p>
                  <p className="text-muted-foreground">Años en el mercado</p>
                </div>
              </div>
            </div>
            
            {/* Decorative element */}
            <div className="absolute -top-8 -left-8 w-32 h-32 bg-primary/10 rounded-full blur-2xl"></div>
          </div>

          {/* Content Side */}
          <div className="space-y-8">
            <div>
              <div className="inline-flex items-center gap-2 bg-primary/10 px-4 py-2 rounded-full mb-4">
                <i className="fas fa-info-circle text-primary"></i>
                <span className="text-sm font-medium text-primary">Sobre Nosotros</span>
              </div>
              
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-6">
                Más que una aseguradora,{' '}
                <span className="text-primary">tu socio de confianza</span>
              </h2>
              
              <p className="text-muted-foreground text-lg leading-relaxed mb-6">
                Creemos que un buen seguro no es solo una póliza, sino alguien que te explique, te asesore y esté presente cuando ocurre un imprevisto.
              </p>
              
              <p className="text-muted-foreground text-lg leading-relaxed">
                Por eso analizamos cada caso de forma personalizada, buscando la cobertura que mejor se adapte a tus necesidades y a tu presupuesto.
              </p>
            </div>

            {/* Values Grid */}
            <div className="grid sm:grid-cols-2 gap-4 pt-4">
              {values.map((value, index) => (
                <Card key={index} className="border-0 bg-muted/50 hover:bg-muted transition-colors duration-300">
                  <CardContent className="p-4 flex items-start gap-4">
                    <div className="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className={`fas ${value.icon} text-primary`}></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-foreground mb-1">{value.title}</h4>
                      <p className="text-sm text-muted-foreground">{value.description}</p>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>

            {/* Stats */}
            <div className="flex flex-wrap gap-8 pt-6 border-t border-border">
              <div className="text-center">
                <p className="text-4xl font-bold text-primary">+1000</p>
                <p className="text-sm text-muted-foreground">Clientes</p>
              </div>
              <div className="text-center">
                <p className="text-4xl font-bold text-primary">+2000</p>
                <p className="text-sm text-muted-foreground">Pólizas Activas</p>
              </div>
              <div className="text-center">
                <p className="text-4xl font-bold text-primary">+15</p>
                <p className="text-sm text-muted-foreground">Años de Experiencia</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
